import { z } from 'zod'

import { BusinessErrorSchema } from 'shared/api/common/schemas/errors'

export const InstagramApiSchema = BusinessErrorSchema.extend({
  field: z.literal('easy_builder_instagram_api_error'),
})

export const ValidationStructureSchema = BusinessErrorSchema.extend({
  field: z.literal('easy_builder_validation_structure'),
})

export const ValidationProSchema = BusinessErrorSchema.extend({
  field: z.literal('easy_builder_validation_pro'),
})

export const ValidationNextPostSchema = BusinessErrorSchema.extend({
  field: z.literal('easy_builder_validation_next_post'),
})

export const FlowProcessSchema = BusinessErrorSchema.extend({
  field: z.literal('easy_builder_flow_process_error'),
})

export const EasyBuilderChannelNotConnectedSchema = BusinessErrorSchema.extend({
  field: z.literal('easy_builder_channel_not_connected_error'),
})

export const EasyBuilderGeneralSchema = BusinessErrorSchema.extend({
  field: z.literal('easy_builder_general'),
})
